import { render, staticRenderFns } from "./Economy.vue?vue&type=template&id=beeb2e44&scoped=true&"
import script from "./Economy.vue?vue&type=script&lang=js&"
export * from "./Economy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beeb2e44",
  null
  
)

export default component.exports